$shm_dashboard_app_menu $mol_page
	agent_enabled false
	monitoring_only false
	attr *
		^
		monitoring_only <= monitoring_only
	dashboard_rows /$mol_view
	app_section \mentions
	agent_opened? false
	wordstat_enabled false
	mentions_enabled true
	mention_stats_enabled false
	dashboard_title_current \BA
	title \Мониторинг+
	head /
		<= Title
		<= Tools
	tools <= tools_rows /
	Lights $mol_lights_toggle
	Agent_toggle $shm_hitalama_mbutton
		hint \ИИ-агент
		checked? <=> agent_opened? false
	sub <= page_rows /
	App_menu $mol_view
		sub /
			<= App_menu_list $mol_list
				rows <= app_menu_rows /
					<= Mentions_link
					<= Mention_stats_link
					<= Wordstat_link
					<= Agent_link
			<= Settings_link
	Mentions_link $mol_link
		arg <= mentions_arg *
		current <= mentions_current false
		title \Мониторинг упоминаний
	Settings_link $mol_link
		arg *
			section \settings
		title \Настройки
	Wordstat_link $mol_link
		arg <= wordstat_arg *
		current <= wordstat_current false
		title \Wordstat
	Mention_stats_link $mol_link
		arg <= mention_stats_arg *
		current <= mention_stats_current false
		title \Статистика упоминаний
	Agent_link $mol_link
		arg <= agent_arg *
		current <= agent_current false
		title \М+ Агент
	Docs_link $mol_link
		arg *
			section \docs
		title \Документация
	body /
		<= App_menu
		<= Foot_profile_card $mol_view
			sub /
				<= Profile $shm_ba_profile_switch
	foot /
		<= Footer $shm_hitalama_footer
			version <= version_data_version \-
			date <= version_data_date \-
